import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
import Text from '../Text';
const Root = styled(Text).withConfig({
  displayName: "FormControlLabel__Root",
  componentId: "fv8tle-0"
})(["", " color:var(--color-gray-100);margin-left:var(--size-spacing-02);&:hover{color:var(--color-gray-100);}", " ", " ", ""], ScopedCssBaseline, ({
  error
}) => error && css(["color:var(--color-red-60);&:hover{color:var(--color-red-60);}"]), ({
  disabled
}) => disabled && css(["color:var(--color-gray-50);&:hover{color:var(--color-gray-50);}"]), ({
  inverted
}) => inverted && css(["color:var(--color-white);&:hover{color:var(--color-white);}"]));
const FormControlLabel = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Root, _extends({
    ref: ref
  }, rest, {
    forwardedAs: "label",
    token: Text.tokens.TEXT_MD_REGULAR
  }), children);
});
FormControlLabel.displayName = 'FormControlLabel';
FormControlLabel.propTypes = {
  /**
   * Sets the children
   */
  children: PropTypes.node.isRequired,

  /**
   * Sets the inverted style
   */
  inverted: PropTypes.bool,

  /**
   * Sets the disabled style
   */
  disabled: PropTypes.bool,

  /**
   * Sets the error style
   */
  error: PropTypes.bool
};
export default FormControlLabel;